module.exports = __webpack_public_path__ + "static/media/PeopleNoConsumables_Desktop_2x.f4cbc588.jpg";